// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3IE3V","disabled":"FileBtn_disabled__9BId6","warn":"FileBtn_warn__Xb5Bv","fade":"FileBtn_fade__2erV8"};